export enum ShowToType {
  VisibleToAgents = 'visible_to_agents',
  VisibleToNoticeBoard = 'visible_to_notice_board',
}
